<p>settingsandpermissions works!</p>
